/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, STitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import ImgPoint from '../../../../../../assets/cybersecurity2026/finger.gif';
import Quiz from '../../components/Quiz';

interface ListItem {
  id: string;
  text: string;
  link?: boolean;
}

interface ListItem1 {
  title: string;
  con: string[];
}

interface ParagraphsSettings {
  title: string;
  l1Title1: string;
  l1Title2: string;
  l2Title1: string;
  l2Lists: ListItem1[];
  quiz: any;
  questionTitle: string;
  l2Text1: string;
}

interface Settings {
  paragraphs: ParagraphsSettings[];
}

interface ISection2Props {
  settings: Settings;
}

const Section2: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '6';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';

  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[5],
    [settings?.paragraphs]
  );

  const updateComponentState = useUpdateComponentState();

  const [state, setState] = useState({
    deepfakeFlagLeft: false,
    deepfakeFlagRight: false,
    quiz: false,
  });

  React.useEffect(() => {
    if (state.deepfakeFlagRight && state.deepfakeFlagLeft) {
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1230pm-section5-1'
      );
    }
  }, [p_course, p_topic, state.deepfakeFlagLeft, state.deepfakeFlagRight]);

  const MoreConciseComponent = () => (
    <>
      {paragraphsSettings?.l2Lists?.map(({ title, con }, index) => (
        <div className="prevent-deepfake-item" key={index}>
          <div className="title-style">{title}</div>
          {con.map((em) => (
            <div className="prevent-deepfake-item-con" key={em}>
              {em}
            </div>
          ))}
        </div>
      ))}
    </>
  );

  const quiz = paragraphsSettings?.quiz;

  return (
    <div className="topic-section-5">
      <CTitle title={paragraphsSettings?.title} />
      {/* section1 part1 */}
      <div className="case-study" id="cybersecurity2026-topic900-section2-3">
        <div
          className="case-study-left"
          onClick={() => setState({ ...state, deepfakeFlagLeft: true })}
        >
          {!state.deepfakeFlagLeft ? (
            <img src={ImgPoint} alt="" />
          ) : (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.l1Title1}
            </span>
          )}
        </div>
        <div
          className="case-study-right"
          onClick={() => setState({ ...state, deepfakeFlagRight: true })}
        >
          {!state.deepfakeFlagRight ? (
            <img src={ImgPoint} alt="" />
          ) : (
            <span className="focus-in-expand-fwd">
              {paragraphsSettings?.l1Title2}
            </span>
          )}
        </div>
      </div>

      {/* section1 part2 */}
      <div className="prevent-deepfake">
        <STitle title={paragraphsSettings?.l2Title1} />
        <div
          className="prevent-deepfake-talk"
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.l2Text1,
          }}
        ></div>
        <div className="prevent-deepfake-list">
          <div className="prevent-deepfake-list-box">
            <MoreConciseComponent />
          </div>
        </div>
      </div>

      {/* question */}
      <div
        id="cybersecurity2026-topic1230pm-section5-question"
        className="topic-quiz"
      >
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={paragraphsSettings.quiz?.description}
          question={paragraphsSettings.quiz?.question}
          options={paragraphsSettings.quiz?.options}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'cybersecurity2026-topic1230pm-section5-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
